import CraftSelectTypeFormItem from "./craft-select-type-form-item";
import CraftSelectIdFormItem from "./craft-select-id-form-item";
import CraftSelectTypeIconFormItem from "./craft-select-type-icon-form-item";


const CraftFormItems = {
    SelectType: CraftSelectTypeFormItem,
    SelectId: CraftSelectIdFormItem,
    SelectTypeIcon: CraftSelectTypeIconFormItem,
};

export default CraftFormItems;